/**
 * Runtime configuration loader
 * Loads config from /config.json at runtime instead of build-time env vars
 */

class AppConfig {
  constructor() {
    this.config = null;
    this.loading = false;
    this.loaded = false;
  }

  async load() {
    if (this.loaded) {
      return this.config;
    }

    if (this.loading) {
      // Wait for ongoing load
      while (this.loading) {
        await new Promise(resolve => setTimeout(resolve, 10));
      }
      return this.config;
    }

    this.loading = true;

    try {
      console.log('Loading runtime configuration...');
      
      // Use environment variables directly (set by deployment scripts)
      this.config = {
        MAIN_API_URL: process.env.REACT_APP_MAIN_API_URL || process.env.MAIN_API_URL,
        WS_API_URL: process.env.REACT_APP_WS_API_URL || process.env.WS_API_URL
      };
      
      console.log('Configuration loaded from environment:', this.config);
      this.loaded = true;
      
      return this.config;
    } finally {
      this.loading = false;
    }
  }

  get(key) {
    if (!this.loaded) {
      console.warn('Config not loaded yet, call await AppConfig.load() first');
      return null;
    }
    return this.config[key];
  }

  getMainApiUrl() {
    return this.get('MAIN_API_URL');
  }

  getWebSocketUrl() {
    // First try explicit WebSocket URL
    const explicitWsUrl = this.get('WS_API_URL');
    if (explicitWsUrl) {
      return explicitWsUrl + '/query/stream';
    }

    // Fallback: Auto-generate WebSocket URL from main API URL
    const mainApiUrl = this.getMainApiUrl();
    if (!mainApiUrl) return null;

    return mainApiUrl.replace(/^https?:\/\//, 'ws://') + '/query/stream';
  }
}

// Export singleton instance
export const appConfig = new AppConfig();
export default appConfig;